import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import ElementHeightObserver from 'components/ElementHeightObserver';
import { MARKET_GRAPH_BASE_URL } from 'constants/locations';
import { ChartSelections, MARKET_GRAPH_SELECTION_PARAM_NAME } from 'constants/marketGraph';
import { setIsMarketDataLoaded } from 'redux/modules/marketGraph';
import { MarketGraphMobilePopupItem } from 'types/marketGraph';

import MarketGraphPopUp from './components/MarketGraphPopUp/MarketGraphPopUp';

export default function MarketGraphLineChartSelectionPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { marketId, selectionId, selection, handicap } = useParams<{
    marketId: string;
    selectionId: string;
    handicap: string;
    selection: string;
  }>();
  const navigate = useNavigate();

  const chartSelections: MarketGraphMobilePopupItem[] = [
    { label: t('account.mybets.labels.odds'), value: ChartSelections.odds },
    { label: t('marketGraph.labels.chance'), value: ChartSelections.chance }
  ];

  const handleSave = (newSelection: string | number) => {
    dispatch(setIsMarketDataLoaded(false));

    navigate(
      `${MARKET_GRAPH_BASE_URL}/${marketId}/${selectionId}/${handicap}?${MARKET_GRAPH_SELECTION_PARAM_NAME}=${newSelection}`,
      { replace: true }
    );
  };

  return (
    <ElementHeightObserver>
      <MarketGraphPopUp
        items={chartSelections}
        defaultValue={(selection as string) || ChartSelections.odds}
        title={t('marketGraph.labels.lineChartData')}
        onSave={handleSave}
        goBackOnSave={false}
      />
    </ElementHeightObserver>
  );
}
